import { render } from "./EventMapWidgetConfig.vue?vue&type=template&id=5b4db8ad&scoped=true"
import script from "./EventMapWidgetConfig.vue?vue&type=script&lang=js"
export * from "./EventMapWidgetConfig.vue?vue&type=script&lang=js"

import "./EventMapWidgetConfig.vue?vue&type=style&index=0&id=5b4db8ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4db8ad"],['__file',"src/containers/widget/configs/EventMapWidgetConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b4db8ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b4db8ad', __exports__)) {
    api.reload('5b4db8ad', __exports__)
  }
  
  module.hot.accept("./EventMapWidgetConfig.vue?vue&type=template&id=5b4db8ad&scoped=true", () => {
    api.rerender('5b4db8ad', render)
  })

}


export default __exports__